import { render, staticRenderFns } from "./bindmpwd.vue?vue&type=template&id=903c4752&scoped=true&"
import script from "./bindmpwd.vue?vue&type=script&lang=js&"
export * from "./bindmpwd.vue?vue&type=script&lang=js&"
import style0 from "./bindmpwd.vue?vue&type=style&index=0&id=903c4752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903c4752",
  null
  
)

export default component.exports